// Global window manager — เก็บรายการ WindowFrame ที่เปิดอยู่ไว้ที่นี่ (นอก React tree ของแต่ละหน้า)
// ให้หน้าต่างที่เปิด/ย่อไว้ไม่ถูก unmount ทิ้งตอนเปลี่ยนหน้า/เปลี่ยนเส้นทาง (เหมือนพฤติกรรม taskbar
// ของ Windows OS — minimize แอปไว้แล้วสลับไปทำหน้าจออื่นต่อ แอปที่ minimize ไม่หายไปไหน)
// ต้อง mount <WindowManager /> ไว้ที่ root (index.js) นอก <Switch>/<Route> เพียงจุดเดียว

let windows = []; // [{ id, title, subtitle, taskbarLabel, defaultWidth, defaultHeight, render, onClose }]
const listeners = new Set();

const notify = () => listeners.forEach((cb) => cb(windows));

// เปิดซ้ำ id เดิมที่เปิดอยู่แล้ว → ไม่ทำอะไร (ให้หน้าต่างเดิมยังอยู่ตำแหน่งเดิม ไม่รีเซ็ต)
export const openWindow = (descriptor) => {
  if (windows.some((w) => w.id === descriptor.id)) return;
  windows = [...windows, descriptor];
  notify();
};

export const closeWindow = (id) => {
  windows = windows.filter((w) => w.id !== id);
  notify();
};

export const subscribeWindows = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};
